import { createRoot } from 'react-dom/client';
const rootNode = document.getElementById('render-app') || document.createElement('div');
const contextMenuNode = document.getElementById('render-context-menu') || document.createElement('div');
export const rootContainer = createRoot(rootNode);
export const rootContextMenu = createRoot(contextMenuNode);
